import { render, staticRenderFns } from "./DiscountChart.vue?vue&type=template&id=623f0278"
import script from "./DiscountChart.vue?vue&type=script&lang=js"
export * from "./DiscountChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports